/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Affiliate_TierInputs */

const en_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate Tier`)
};

const es_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel de afiliado`)
};

const fr_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau d'affiliation`)
};

const de_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate-Stufe`)
};

const ja_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アフィリエイトティア`)
};

const zh_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推广等级`)
};

const ar_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستوى المسوق`)
};

const id_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat Afiliasi`)
};

const it_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello Affiliato`)
};

const ru_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уровень партнера`)
};

const pt_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível de Afiliado`)
};

const ko_affiliate_tier = /** @type {(inputs: Affiliate_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어필리에이트 등급`)
};

/**
* | output |
* | --- |
* | "Affiliate Tier" |
*
* @param {Affiliate_TierInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const affiliate_tier = /** @type {((inputs?: Affiliate_TierInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Affiliate_TierInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_affiliate_tier(inputs)
	if (locale === "es") return es_affiliate_tier(inputs)
	if (locale === "fr") return fr_affiliate_tier(inputs)
	if (locale === "de") return de_affiliate_tier(inputs)
	if (locale === "ja") return ja_affiliate_tier(inputs)
	if (locale === "zh") return zh_affiliate_tier(inputs)
	if (locale === "ar") return ar_affiliate_tier(inputs)
	if (locale === "id") return id_affiliate_tier(inputs)
	if (locale === "it") return it_affiliate_tier(inputs)
	if (locale === "ru") return ru_affiliate_tier(inputs)
	if (locale === "pt") return pt_affiliate_tier(inputs)
	return ko_affiliate_tier(inputs)
});